import React from 'react';

const Tab = (props) => {
    const {header, body, identifier, isActive, selectTab} = props;
    const classname = isActive ? `gr-4 tab-is-active ${identifier}` : `gr-4 ${identifier}`;

    return(
        <div className={classname} onClick={selectTab}>
            <h1>{header}</h1>
            <p>{body}</p>
        </div>
    );
}

export default Tab;



// WEBPACK FOOTER //
// ./web/js/components/tab.js